<template>
  <van-popup v-model:show="visable" round position="top" v-if="visable" style="height: 100%;" class="scan-popup">
    <div class="scan-header" style="overflow: hidden;background-color: rgba(0, 0, 0, 0);position: fixed;width: 100%;z-index: 1000;font-size: 18px;color: white;">
      <div style="float: left;text-align: center;padding: 10px 0px;width: 25%;" @click="closePopup">返回</div>
      <div style="float: left;text-align: center;padding: 10px 0px;width: 50%;">扫一扫</div>
    </div>
    <div class="scan" scroll="no">
      <stream-barcode-reader
        class="fullscreen-scanner"
        @decode="onDecode"
      ></stream-barcode-reader>
      <image-barcode-reader @decode="onDecode" class="scan-im-reader"></image-barcode-reader>
      <div class="scan-img-btn" @click="openImg">
        <div><span style="font-size: 30px;"><i class="el-icon-picture"></i></span></div>
        <div style="font-size: 12px;line-height: 12px;">相册</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { StreamBarcodeReader, ImageBarcodeReader } from "vue-barcode-reader";

export default {
  components: {
    'stream-barcode-reader': StreamBarcodeReader,
    'image-barcode-reader': ImageBarcodeReader,
  },
  props: {
    visable: {
      type: Boolean,
      default: () => {
        return false
      },
    }
  },
  data() {
    return {
      result: '',
      error: '',
    }
  },
  created() {},
  mounted() {
    document.getElementsByClassName('scan-im-reader')[0].attributes.removeNamedItem('capture');
  },
  methods: {
    // 打开相册
    openImg() {
      document.getElementsByClassName('scan-im-reader')[0].click();
    },
    onDecode(barcode) {
      this.$emit('detect', barcode)
      this.$emit('update:visable', false)
    },
    // 返回
    closePopup() {
      this.$emit('update:visable', false);
    }
  }
}
</script>

<style lang="scss" scoped>
  .scan {
    overflow: hidden;
    height: 100%;

    .scan-img-btn {
      width: 50px;
      height: 50px;
      background: grey;
      border-radius: 50%;
      position: absolute;
      bottom: 40px;
      left: 0px;
      right: 0px;
      margin: 0px auto;
      text-align: center;
      color: white;
      padding-top: 5px;
    }
  }

  .van-popup--top.scan-popup {
    border-radius: 0px;
  }

  .fullscreen-scanner {
    /deep/ video { 
      max-width: none;
      max-height: none;
      height: 100vh;
    }

    /deep/ .overlay-element {
      clip-path: polygon(
          0% 0%,
          0% 100%,
          20% 100%,
          20% 20%,
          80% 20%,
          80% 50%,
          20% 50%,
          20% 100%,
          100% 100%,
          100% 0%
      )
    }

    /deep/ .laser {
      top: 30%;
    }

    /deep/ .scan-im-reader {
      display: none;
    }
  }
  
</style>


<style>
  .scanner-container {
    height: 103vh;
  }
</style>
